import Indicador from "..";
import ABAEditFields from "./components/ABAEditFields";
import { ABAParamFields } from "./components/ABAParamFields";
import abaReport from "./reports";
import abaReportSummary from "./reports/summary";

export default class ABA extends Indicador {
    static get fullName() {
        return "Abalo de Soqueira";
    }

    static get abbrev() {
        return "ABA";
    }

    static paramFields(tipoIndicadorField = '') {
        return <ABAParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <ABAEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return abaReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return abaReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        const total = apontamento.coletas.length;
        let sumAbalo = 0;

        for (const coleta of apontamento.coletas) {
            // 'avaliados' deve ser um número != 0.
            if (coleta.abalados && f(coleta.avaliados)) {
                coleta.abalo = (100 * f(coleta.abalados)) / f(coleta.avaliados);
                sumAbalo += coleta.abalo;

                coleta.abalo = f(coleta.abalo).toFixed(2);
            } else {
                coleta.abalo = "0.00";
            }
        }

        return (sumAbalo / total).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatusInverte(conformidade, meta, 110, 100, 90);
    }
    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },
            { title: "Turno", field: "turno", width: 'auto' },//

            {
                title: "Tocos Abalados", width: 'auto', getValue: (a) => {
                    let sun = a.coletas?.reduce((total, c) => total += parseInt(c.abalo), 0)
                    return sun
                }
            },
            {
                title: "Tocos Avaliados", width: 'auto', getValue: (a) => {
                    let sun = a.coletas?.reduce((total, c) => total += parseInt(c.avaliados), 0)
                    return sun
                }
            },


            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },

        ]
    }

    static getResultStr(apontamento) {
        let tocosAbalados = apontamento.coletas?.reduce((total, c) => total += parseInt(c.abalo), 0)
        let tocosAvaliados = apontamento.coletas?.reduce((total, c) => total += parseInt(c.avaliados), 0)

        return "Tocos Abalados: " + tocosAbalados +
            " e Tocos Avaliados: " + tocosAvaliados
    }
}
